var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUnsavedAutosaveIcon = function SvgUnsavedAutosaveIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#F5B95F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5171 13.7452C12.8568 14.0849 13.4055 14.0849 13.7452 13.7452C14.0762 13.4055 14.0762 12.8481 13.7452 12.5171L11.2281 9.99999L13.7452 7.48285C14.0849 7.14317 14.0849 6.59445 13.7452 6.25476C13.4055 5.91508 12.8568 5.91508 12.5171 6.25476L9.99999 8.77191L7.48285 6.25476C7.14317 5.91508 6.59445 5.91508 6.25476 6.25476C5.91508 6.59445 5.91508 7.14317 6.25476 7.48285L8.77191 9.99999L6.25476 12.5171C5.91508 12.8568 5.91508 13.4055 6.25476 13.7452C6.59445 14.0849 7.14317 14.0849 7.48285 13.7452L9.99999 11.2281L12.5171 13.7452Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUnsavedAutosaveIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "unsaved-autosave-icon.c3827ff0ac53c9a93d3d1caf168fb1e6.svg";